// extracted by mini-css-extract-plugin
module.exports = {"multiAmountWidget":"multiAmountWidget__AWntN","menu":"menu__j-SZN","correctionInput":"correctionInput__BAi5S"};